/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Practice<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  getLessonQuizDetail = (lessonId: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Practice/GetLessonQuiz/${lessonId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  getFreeTestList = (query: { subject?: number; onlyCompleted?: boolean; facultyId?: string }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Practice/GetFreeTest`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  getModelPlanList = (query: { facultyId: string }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Practice/GetModelPlan`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  getModelTestList = (query: { facultyId: string; subject: number }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Practice/GetModelTest`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  submitCreate = (data: any, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Practice/Submit`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  checkCreate = (data: { questionId: string; selectedOptionIds: string[] }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Practice/Check`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  getStatsList = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Practice/GetStats`,
      method: "GET",
      secure: true,
      ...params,
    });
  getModelHistoryList = (query: { facultyId: string }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Practice/GetModelHistory`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
}
